export default __webpack_public_path__ + "static/media/pedrotechspecial.425951cb.jpg";